<template>
    <div class="col-xs-12 col-md-4 col-lg-3 col-xl-2 system-messages">
        <header>System Messages</header>
        <section>
            <template v-if="isLoading && this.isFirstRun('transactions_status')">
                <loader></loader>
            </template>
            <template v-else-if="this.hasData('transactions_status')">
                <div v-if="this.data.hasOwnProperty('call_status') && this.data.call_status === 'FAILED'"
                     class="alert alert-info">
                    {{ this.data.message }}
                </div>
                <template v-else>
                    <ul class="system-messages">
                        <li class="day" v-for="(entries, date) in this.data">
                            <span class="timestamp">{{ date }}</span>
                            <ul>
                                <li v-for="(entry, index) in entries">

                                    <span class="timestamp-hour">{{ entry.log_time }}</span>
                                    <span class="message-bg">
                                        <template v-if="entry.action_metadata && entry.action_metadata.action_name && entry.action_metadata.action_name !== ''">
                                            <span>{{entry.action_metadata.action_name}}</span><br>

                                            <template v-if="entry.action_metadata.entity_name && entry.action_metadata.entity_name !== ''">
                                                <span>Entity: {{entry.action_metadata.entity_name}}</span><br>
                                            </template>

                                            <template v-if="entry.action_metadata.domain_name && entry.action_metadata.domain_name !== ''">
                                                <span>Domain: {{entry.action_metadata.domain_name}}</span><br>
                                            </template>
                                        </template>
                                        <template v-else>
                                            <span class="target">Type: </span>
                                            <span class="message">{{ entry.action_type }}</span><br>
                                        </template>

                                        <span>Status:
                                            <span :class="entry.status_class">
                                                <template v-if="entry.status.toLowerCase() == 'in progress'">
                                                    <fa icon="spinner" spin/>
                                                </template>
                                                {{ entry.status }}
                                            </span>
                                        </span>

                                        <template v-if="entry.has_details === 1">
                                            <button
                                                    @click="show_details(date, index)"
                                                    class="c-btn c-btn-info"
                                            >
                                                Details
                                            </button>
                                        </template>
                                        <br>
                                        <span><em>by: {{ entry.username }}</em></span>
                                    </span>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </template>
            </template>
            <template v-else>
                <div class="alert alert-info">No recent operations</div>
            </template>
        </section>
        <transaction-details-ccs-modal
                :min-width="200"
                :min-height="200"
                :pivot-y="0.5"
                :adaptive="true"
                :scrollable="true"
                :reset="true"
                width="60%"
                height="auto"
        >
            <template slot="content">
                <TransactionDetails
                        v-if="transaction_detail_index > -1"
                        :transaction_data="data[transaction_detail_date][transaction_detail_index]"
                ></TransactionDetails>
            </template>
        </transaction-details-ccs-modal>
    </div>
</template>
<script>
	import {mapState, mapGetters} from "vuex";
	import CcsModal from "@/components/CcsModal.vue";
	import TransactionDetails from "@/components/transactions/TransactionDetails.vue";

	export default {
		data()
		{
			return {
				transaction_detail_date: -1,
				transaction_detail_index: -1,
			};
		},
		components: {
			TransactionDetailsCcsModal: CcsModal,
			TransactionDetails
		},
		computed: {
			...mapState({
				data: (state) => state.platformUpdates.data.transactions_status,
				isLoading: (state) => state.platformUpdates.isLoading
			}),
			...mapGetters({
				hasData: "platformUpdates/hasData",
				isFirstRun: "platformUpdates/isFirstRun"
			})
		},
		watch: {
			data: function (val) {
				console.log('transaction status data: ', val);
			}
		},
		mounted()
		{
			this.$store.commit("platformUpdates/addPlatformUpdateRequest", {
				tag: "transactions_status",
				callback: "_handleTransactionStatus"
			});
		},
		methods: {
			show_details: function (transaction_date, transaction_index) {
				this.transaction_detail_date = transaction_date;
				this.transaction_detail_index = transaction_index;
				this.$modal.show("transaction-details-ccs-modal-dialog", {
					type: "info",
					//title: "Transaction details",
					//text: "Some details will follow",
					buttons: [
						{
							title: "Close",
							default: true // Will be triggered by default if 'Enter' pressed.
						}
					]
				});
			}
		}
	};
</script>
